import { BILLING_CYCLE, NO_NEED_CHANGE_PRICE_CYCLE } from '@/common/constants';
import { billingCycleToValueMap } from '@/utils';
import { getDiscountedMonthPlanUnit } from '@/common/product-unit';
import { isString } from 'lodash';


export default {
  methods: {
    useSmallSize(text) {
      return isString(text) && text.length > 5
    },
    showBilledText(cycle) {
      return billingCycleToValueMap[cycle]
    },
    getMergedBilledText(billingCycle, amount, unit) {
      const unitText = this.getDiscountedMonthPlanUnit(unit)
      if (this.showBilledText(billingCycle)) {
        return `${unitText}, <span class="opc-price-total-bill">${this.getBilledPriceIfNeed(billingCycle, amount)}</span> ${this.getBillText(billingCycle)}`
      } else {
        return `${unitText}`
      }
    },
    getPriceOfMonth(amountCents, billingCycle, options = {}) {
      return this.$priceByMonth(amountCents, billingCycle, options);
    },
    getDiscountedMonthPlanUnit(unit) {
      return getDiscountedMonthPlanUnit(unit);
    },
    getBilledPriceIfNeed(billingCycle, amount) {
      if (NO_NEED_CHANGE_PRICE_CYCLE.includes(billingCycle)) {
        return '';
      }
      return this.$money(amount, { forceDiff: true })
    },
    getBillText(billingCycle) {
      if (NO_NEED_CHANGE_PRICE_CYCLE.includes(billingCycle)) {
        return this.$t('billing.bill_monthly')
      }
      switch (billingCycle) {
        case BILLING_CYCLE.ANNUAL:
          return this.$t('billing.bill_annually')
        case BILLING_CYCLE.QUARTERLY:
          return this.$t('billing.bill_quarterly')
        case BILLING_CYCLE.TWO_YEARS:
          return this.$t('billing.bill_two_years')
        case BILLING_CYCLE.THREE_YEARS:
          return this.$t('billing.bill_three_years')
      }
      return ''
    },
    // ZOOM-797378
    ariaPriceOfMonthForLabel(plan) {
      try {
        const priceObject = this.getPriceOfMonth(plan.amount, plan.billing_cycle, { forceDiff: true });
        const symbol = `${priceObject?.currency?.symbol}`;
        const isSymbolPrefix = priceObject?.currency?.place === 'begin';
        const price = `${priceObject.integer}${priceObject?.decimal ? `.${priceObject?.decimal}`: ''}`;
        return isSymbolPrefix ? `${symbol}${price}`: `${price}${symbol}`
      } catch(e) {
        return '';
      }
    }
  }
}
